import React from "react";
import "../../../src/components/CustomSingleButtonPopup/CustomSingleButtonPopup.css";

const CustomSingleButtonPopup = ({ title, btn1, btn1Click }) => {

    return (
        <>
            <div className="custom-single-butto-popup-section">
                <div className="custom-single-butto-popup-wrapper">
                    <div className="custom-single-butto-popup-container">
                        <h2>{title}</h2>
                        <div className="custom-single-popup-btn">
                            <button type="submit" onClick={btn1Click}>{btn1}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomSingleButtonPopup;